import React, { Component, useContext } from 'react';
import { Row, Col, Popconfirm, Space, Spin, Layout, message, Typography, Card, List } from 'antd'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


import User from "../../../Hooks/Logged";
import usePermissions from "../../../Hooks/usePermissions";
import FloatingButton from "../../Widgets/Floating Button/FloatingButton";
import PageHeader from '../../Widgets/PageHeader/PageHeader';

import ModalCategorias from './ModalCategorias.js'
import { ButtonDelete, ButtonEdit } from '../../Widgets/Buttons';
import useSearch from '../../../Hooks/useSearch';
import { getResponseError } from '../../Utils'

const { Content } = Layout;
const { Text } = Typography;
/**
 *
 *
 * @export
 * @class Categorias
 * @extends {Component}
 * @description Vista de Project Manager
 */
class Categorias extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modalVisible: false,
            categoria_id: undefined,

            categorias: {
                data: [],
                limit: 10,
                page: 1,

                total: 0,
                pages: 0,

            }
        }
    }

    componentDidMount() {
        this.props.setShowSearch(true)
        this.getCategorias();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search) {
            this.getCategorias({ page: 1 })
        }
    }
    componentWillUnmount() {
        this.props.setShowSearch(false)
    }


    /**
    * @memberof Categorias
    * @method getCategorias
    * @description Trae las categorias 
    * 
    */
    getCategorias = ({
        page = this.state.categorias.page,
        limit = this.state.categorias.limit,

        search = this.props.search

    } = this.state.categorias) => {
        this.setState({ loading: true, categorias: { ...this.state.categorias, page, limit } })
        axios.get('/categorias', {
            params: { page, limit, search }
        }).then(({ data }) => {
            this.setState({ categorias: data })
        }).catch(error => {
            message.error(error.response?.data?.message)
        }).finally(() => this.setState({ loading: false }))
    }

    render() {

        const { categorias } = this.state

        return (
            <>
                <Spin spinning={false}>
                    <PageHeader
                        className="admin-page-header"
                        title="Categories"
                    />

                    <Content className="admin-content content-bg pd-1">
                        <div style={{ overflowX: "auto" }}>
                            <List
                                loading={this.state.loading}
                                className="component-list responsive"
                                itemLayout="horizontal"
                                locale={{ emptyText: "Categories not found" }}
                                dataSource={categorias.data}
                                pagination={{
                                    current: categorias.page,
                                    pageSize: categorias.limit,
                                    total: categorias.total,
                                    showSizeChanger: true,
                                    position: 'bottom',
                                    onChange: (page, limit) => {
                                        this.getCategorias({ page, limit })
                                    }
                                }}
                                header={
                                    <Row className="width-100 component-list-header" wrap={false} gutter={16}>
                                        <Col style={{ minWidth: 160, flex: 1 }}>
                                            <Text strong>Name</Text>
                                        </Col>
                                        <Col style={{ minWidth: 220, flex: 2 }}>
                                            <Text strong>Description</Text>
                                        </Col>
                                        <Col style={{ minWidth: 160, flex: 1 }}>
                                            <Text strong>Actions</Text>
                                        </Col>
                                    </Row>
                                }
                                renderItem={item => (
                                    <List.Item className="component-list-item">
                                        <Card className="card-list">
                                            <Row className="width-100" gutter={[6, 8]} wrap={false}>
                                                <Col style={{ minWidth: 160, flex: 1 }}>
                                                    <Text strong>{item.nombre}</Text>
                                                </Col>
                                                <Col style={{ minWidth: 220, flex: 2 }}>
                                                    <Text ellipsis>{item.descripcion}</Text>
                                                </Col>
                                                <Col style={{ minWidth: 160, flex: 1 }}>
                                                    <Space>
                                                        <ButtonEdit
                                                            title="Edit"
                                                            onClick={() => { this.setState({ modalVisible: true, categoria_id: item._id }) }}
                                                        />
                                                        <Popconfirm
                                                            placement="topRight"
                                                            title="Do you want to delete this category?"
                                                            onConfirm={() => axios.delete('/categorias', { params: { id: item._id } })
                                                                .then(() => {
                                                                    this.getCategorias()
                                                                    message.success('Category deleted!')
                                                                })
                                                                .catch(e => message.error(getResponseError(e.response, 'Can\'t delete category')))}
                                                            okText="Yes"
                                                            cancelText="Cancel"
                                                        >
                                                            <ButtonDelete title="Delete" />
                                                        </Popconfirm>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                        </div>
                    </Content>

                    <FloatingButton title="New register" onClick={() => this.setState({ modalVisible: true })} />


                </Spin>
                <ModalCategorias
                    visible={this.state.modalVisible}
                    onClose={() => {
                        this.setState({ modalVisible: false, categoria_id: undefined })
                        this.getCategorias()
                    }}
                    categoria_id={this.state.categoria_id}
                />
            </>
        )

    }
}

export default function Vista(props) {

    const { search, setShow } = useSearch()
    const user = useContext(User);

    const permisos = usePermissions(user?.rol_id?.permisos, {
        editarCategorias: ["categorias", "edit"],
        deleteCategorias: ["categorias", "delete"],
        createCategorias: ["categorias", "create"]

    });

    return <Categorias {...props} search={search} setShowSearch={setShow} navigate={useNavigate()} {...permisos} />

}